<script lang="ts" module>
  import { Spinner } from '@athena-lib/Icons';
  import { Overlay } from '@athena-lib/Overlay';
  import type { CheckoutState } from '@stickerapp-org/checkout-sdk';
  import Editor from './Editor.svelte';
  import type { AtlasResources } from '$lib/server/Atlas/atlasResources';
  import { getCustomStickerCached } from '$lib/checkout.svelte';

  let editorState = $state<{
    type: 'initial' | 'loading' | 'loaded';
    editorData?: string;
    origin?: string;
  }>({
    type: 'initial',
  });

  export const openEditor = async (
    lineItem: CheckoutState['lines'][number],
    origin = 'wizard_editor',
  ) => {
    if (lineItem.content.type !== 'customSticker') {
      return;
    }
    const stickerData = await getCustomStickerCached(lineItem.content.customStickerId);
    if (!stickerData) {
      return;
    }
    editorState = { type: 'loading' };
    const postBody = {
      ...stickerData,
      origin,
    };

    const result = await fetch(`/editor/render_editor`, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(postBody),
    });

    if (!result.ok) {
      editorState = { type: 'initial' };
      return;
    }
    const html = await result.text();

    editorState = { type: 'loaded', editorData: html };
    const event = new CustomEvent('openEditor', { bubbles: true, detail: html });
    document.body.dispatchEvent(event);
  };
</script>

<script lang="ts">
  const { atlasResources }: { atlasResources: AtlasResources } = $props();
</script>

<Overlay
  isOpen={editorState.type === 'loading'}
  onClose={() => {}}
  label={'Loading'}
  overlayClass={'fixed bottom-0 left-0 right-0 top-0'}
  lockScrolling={false}
>
  <div class="relative left-1/2 top-1/2 justify-center text-st-black">
    <Spinner sizeClass="w-20 h-20" />
  </div>
</Overlay>

{#if editorState.type !== 'initial'}
  <Editor
    blok={{
      atlas: { ...atlasResources, data: editorState.editorData },
    }}
  ></Editor>
{/if}
